import { useGetAccountPayableRegularReports } from 'api-hooks/report';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

import PivotReportTemplate from './components/pivot-report-template';

export default function AccountPayableRegularReport() {
  const { t } = useTranslation();

  return (
    <PivotReportTemplate
      title={t('common:account_payable_regular_report')}
      usePivotQuery={useGetAccountPayableRegularReports}
      completeName={['agent']}
    />
  );
}
